.addExtensionLabel:global(.MuiTypography-root) {
	font-weight: 600;
	font-size: 0.9375rem;
	line-height: 1.5;
	letter-spacing: 0;
	color: #000;
	padding-left: 0.25rem;
}

.applicationLink {
	font-weight: 500;
}

.addExtensionFormControl:global(.MuiFormControlLabel-root) {
	margin: 0;
	margin-top: 1.25rem;
	align-items: flex-start;
	gap: 0.25rem;
	width: 100%;
}
